// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  margin-bottom: 20px;\n  padding: 10px 25px;\n  border-radius: 4px;\n}\n#profile-form {\n  margin-top: 10px;\n}\n.container {\n  padding: 0;\n  padding-top: 5rem !important;\n  margin-left: 250px;\n  margin-right: 250px;\n  max-width: calc(100vw - 300px) !important;\n}", ""]);
// Exports
module.exports = exports;
